import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/core/services/api.service';
import { environment } from 'src/environment/environment';

@Injectable({
  providedIn: 'root',
})
export class RecipientsApiService extends ApiService {
  getRecipients$(search?: string): Observable<RecipientDto[]> {
    let params = new HttpParams();

    if (search?.trim()) {
      params = params.set('search', search.trim());
    }

    return this.get('/Recipients/search', params);
  }

  resolveRecipients$(payload: ResolveRecipientsRequest): Observable<RecipientDto[]> {
    return this.post('/Recipients/resolve', payload);
  }
}

export interface RecipientDto {
  id: string;
  name: string;
  email: string;
}

export interface ResolveRecipientDto {
  id?: string;
  name: string;
  email: string;
}

export interface ResolveRecipientsRequest {
  recipients: ResolveRecipientDto[];
}

export const apiRecipientsProtectedResources = [
  {
    httpMethod: 'GET',
    scopes: [...environment.protectedResources.apiRecipients.scopes.read],
  },
  {
    httpMethod: 'POST',
    scopes: [...environment.protectedResources.apiRecipients.scopes.write],
  },
  {
    httpMethod: 'PUT',
    scopes: [...environment.protectedResources.apiRecipients.scopes.write],
  },
  {
    httpMethod: 'DELETE',
    scopes: [...environment.protectedResources.apiRecipients.scopes.write],
  },
];